const canCopyViaApiAsync = async (): Promise<boolean> => {
  const resultStateArray = Array<string>('granted', 'prompt');
  let result = { state: 'unavailable' };

  if (navigator && navigator.permissions) {
    try {
      result = await navigator.permissions.query({
        // @ts-ignore
        name: 'clipboard-write',
      });
    } catch {}
    return resultStateArray.includes(result.state);
  }

  return Promise.resolve(false);
};

export default canCopyViaApiAsync;
